function heroAnimation() {
  // Hero animation
  let tl = anime.timeline({
      easing: 'easeInOutSine',
      duration: 1000
  });
  
  tl
  .add({
      targets: $('body').get(0),
      opacity: [ 0, 1 ],
      easing: 'easeOutQuad',
      duration: 600
  })
  .add({
      targets: '.js-hero-content',
      opacity: [ 0, 1 ],
      translateY: [ 50, 0 ]
  })
  .add({
      targets: '.line-hero-content',
      opacity: [ 0, 1 ],
      translateX: [ 50, 0 ]
  })
  .add({
      targets: '.js-header',
      opacity: [0, 1],
      translateY: [ -50, 0 ]
  }, '-=2000' );
}

function scrollActivate() {
  var bottom_of_window = $(window).scrollTop() + $(window).height();

  $('.js-scroll-activate').each((i, e) => {
      var target = e, offset = 0;

      if($(window).width() > 767){
          if($(target).data('offset') != undefined) {
              offset = $(target).data('offset');
          }
          else {
              offset = 300;
          }
      }
      else {
          offset = 150;
      }

      var top_of_object = $(target).offset().top + offset;

      if( bottom_of_window > top_of_object ) {
          if($(target).css('opacity') == 0) {
              var line_delay = 0;
              $(target).removeClass('js-scroll-activate');

              if($(target).hasClass('js-scroll-activate--individual')) {
                  anime({
                      targets: $(target).find('.js-scroll-individual').get(),
                      opacity: [ 0, 1 ],
                      easing: 'easeOutQuad',
                      duration: 700,
                      delay: anime.stagger(200)
                  });
              }
              else {
                  anime({
                      targets: target,
                      opacity: [ 0, 1 ],
                      translateY: [50, 0],
                      easing: 'easeOutQuad',
                      duration: 700,
                  });
              }
          }
      }
  });
}

function checkNewsletterValue() {
  $('.js-newsletter-check').on('input', function() {
       if($(this).val() != '') {
         $(this).next('.field__label').fadeOut();
       }
       else {
         $(this).next('.field__label').fadeIn();
       }
  });
}

heroAnimation();
// scrollActivate();
checkNewsletterValue();

$(window).on('load', () => {
  var rellax = new Rellax('.rellax', {
    speed: -2.5,
    center: true
  });
});

$(window).on('scroll', () => {
    scrollActivate();
});